// removed by extract-text-webpack-plugin
module.exports = {"box":"eqRCO6vGPOlaZnWKZm5SV","boxTitle":"_1mmHQxy5V7x6YTdRZw8x_6","boxSubtitle":"vm5IOQzIa0nqWhh7hcQrm","boxBar":"_2hGrlefOrrrmb2Y9Bu7efy","content":"_1LCZ7GdDfu1skEId2rBqD9","listing":"_3lJ5c2kxXAvJSPIhztq5yN","listingHeader":"_3BINhPSDMPwL1aV7Mlacnu","listingContent":"_3c1QoG0kg2jmpfeL-OL5bL","boxInfo":"_1L5EV1QFlP2qmgaGUQhHpC","inputFieldLabel":"_2Ch0e21Uxq9KNR7-AnV2_p","inputFieldInput":"_3bH8P__DURlk0pARgLRpZE","inputFieldError":"_2tVYTgXHtZugjZBOD6gBxr","form":"_2E6Lqnz3hPZ0Jzzwx4VMcB","line":"_2z-mXipQzhq_J3HJT5Jk1e"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/NewSchoolLevel/NewSchoolLevel.scss
// module id = 970
// module chunks = 0